<template lang="pug">
.row(v-if="local.mode === 'range'")
  .col-md-5
    .form-group
      label Mode
      select.form-control(v-model="local.mode", @change="onModeChange")
        option(v-for="o in modes" :value="o.value") {{ o.label }}
  .col-md-3
    .form-group
      label Minimum version
      input.form-control(v-model="local.min", placeholder="No limit", @change="emitUpdate")
  .col-md-3
    .form-group
      label Maximum version
      input.form-control(v-model="local.max", placeholder="No limit", @change="emitUpdate")
  .col-md-1.d-flex.align-items-center.justify-content-end
    i.clickable.la.la-minus-circle(@click="remove()", style="font-size: 1.5rem;")
.row(v-else)
  .col-md-5
    .form-group
      label Mode
      select.form-control(v-model="local.mode", @change="onModeChange")
        option(v-for="o in modes" :value="o.value") {{ o.label }}
  .col-md-6
    .form-group
      label Version
      input.form-control(v-model="local.value", placeholder="No limit", @change="emitUpdate")
  .col-md-1.d-flex.align-items-center.justify-content-end
    i.clickable.la.la-minus-circle(@click="remove()", style="font-size: 1.5rem;")
</template>

<style lang="scss"></style>

<script>
export default {
  name: 'os-targeting-version-blacklist-object',
  emits: ['update', 'remove'],
  props: {
    object: {
      type: [Object],
      required: true,
    },
    index: {
      type: [Number],
      required: true,
    },
  },
  data() {
    return {
      modes: [
        { value: 'range', label: 'Range' },
        { value: 'above', label: 'Above' },
        { value: 'below', label: 'Below' },
      ],
      local: this.cloneObject(this.object),
    };
  },
  watch: {
    object: {
      deep: true,
      handler(next) {
        this.local = this.cloneObject(next);
      },
    },
  },
  methods: {
    cloneObject(o) {
      return JSON.parse(JSON.stringify(o || {}));
    },
    remove() {
      this.$emit('remove', this.index);
    },
    onModeChange() {
      if (this.local.mode === 'range') {
        delete this.local.value;
        this.local.min = null;
        this.local.max = null;
      } else {
        delete this.local.min;
        delete this.local.max;
        this.local.value = null;
      }
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update', this.cloneObject(this.local));
    },
  },
};
</script>
